import { Fragment, useEffect, useState } from "react";
import {
  configurationsAPI,
  fetchPublicOrders,
  getHelpArticles,
  searchOrders,
} from "./utils/api";
import { FiFacebook, FiInstagram, FiLinkedin, FiPackage, FiEdit3 } from "react-icons/fi";
import { RiArrowRightSLine } from "react-icons/ri";
import { IoLogoWhatsapp } from "react-icons/io";
import "react-accessible-accordion/dist/fancy-example.css";
import OrdersPage from "./Orders/OrdersPage";
import ContactForm from "./ContactForm";
import FAQSection from "./FAQSection";
import Login from "./Login";
import Footer from "./Footer/Footer";
// import { ClipLoader } from "react-spinners";
import { MdOutlineArrowBack, MdOutlineReplay } from "react-icons/md";
import { AiOutlineMail } from "react-icons/ai";
import { FaWhatsapp, FaYoutube, FaPinterest } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { StyledSocialIconsDiv } from "./styles";
// import { useJitsu } from "@jitsu/react";

function App() {
  const [configurations, setConfigurations] = useState({});
  const [settings, setSettings] = useState({});
  const [orderListActive, setOrderListActive] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [FAQSectionActive, setFAQSectionActive] = useState(false);
  const [helpArticles, setHelpArticles] = useState([]);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [loader, setLoader] = useState(true);
  const [ordersLoader, setOrdersLoader] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [encryptedMid, setEncryptedMid] = useState(null);
  const [orderDetailsActive, setOrderDetailsActive] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [customerName, setCustomerName] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  var URL_PARAMS = new URLSearchParams(window.location.search);
  var merchant_id = URL_PARAMS.get("mid");
  var domain = URL_PARAMS.get("sd");
  // const { id, track } = useJitsu();

  useEffect(() => {
    window.addEventListener("message", function (event) {
      const userObject = event.data;
      // track("widget_loaded");
      if (userObject && userObject.topic === "PRAGMA") {
        // if (
        //   (userObject.userInfo.phone && userObject.userInfo.phone !== null) ||
        //   (userObject.userInfo.email && userObject.userInfo.email !== null)
        // ) {
        //   setPhone(userObject.userInfo.phone.slice(-10));
        //   setEmail(userObject.userInfo.email);
        //   if (!isNaN(userObject.userInfo.phone)) {
        //     setPhone(userObject.userInfo.phone.slice(-10));
        //   } else {
        //     setEmail(
        //       userObject.userInfo.email &&
        //         userObject.userInfo.email.toLowerCase()
        //     );
        //   }
        //   setOtpVerified(true);
        //   setLoader(true);
        //     configurationsAPI(merchant_id).then((resp) => {
        //       setConfigurations(resp.data.data);
        //       setSettings(resp.data.data.settings);
        //       setHelpArticles(resp.data.data.help_center_articles);
        //       setLoader(false);
        //     });
        // } else {
        configurationsAPI(merchant_id, domain).then((resp) => {
          setConfigurations(resp.data.data);
          setSettings(resp.data.data.settings);
          setHelpArticles(resp.data.data.help_center_articles);
          setLoader(false);
        });
      }
    });
  }, []);

  const trackOrders = (token) => {
    setOrdersLoader(true);
    setOrderListActive(true);
    if (
      settings?.merchant?.public_api_key &&
      settings?.merchant?.public_api_key !== ""
    ) {
      fetchPublicOrders(settings, phone, email)
        .then((resp) => {
          setOrderList(resp.data.orders);
          setCustomerName(resp.data.customer_name);
        })
        .finally(() => {
          setOrdersLoader(false);
        });
    } else {
      searchOrders(settings, email, phone, token)
        .then((resp) => {
          setOrderList(resp.data.orders);
          setCustomerName(resp.data.customer_name);
        })
        .finally(() => {
          setOrdersLoader(false);
        });
    }
  };

  return (
    <div className="app">
      <iframe
        id="sessionIframe"
        className="hidden"
        title="sessionIframe"
        src="https://orders.logisy.tech/session"
      ></iframe>
      {loader ? (
        <div className="site-widget-loader"></div>
      ) : openForm ? (
        <ContactForm
          settings={settings}
          setOpenForm={setOpenForm}
          queryReasons={settings.customer_query_reasons}
        />
      ) : orderListActive ? (
        <OrdersPage
          setOrderListActive={setOrderListActive}
          settings={settings}
          phone={phone}
          email={email}
          setOrdersLoader={setOrdersLoader}
          ordersLoader={ordersLoader}
          orderList={orderList}
          setOrderList={setOrderList}
          encryptedMid={encryptedMid}
          setEncryptedMid={setEncryptedMid}
          orderDetailsActive={orderDetailsActive}
          setOrderDetailsActive={setOrderDetailsActive}
          orderDetails={orderDetails}
          setOrderDetails={setOrderDetails}
          customerName={customerName}
          setOtpSent={setOtpSent}
          setOtpVerified={setOtpVerified}
          setEmail={setEmail}
          setPhone={setPhone}
          accessToken={accessToken}
        />
      ) : FAQSectionActive && settings.help_center_widget_enabled ? (
        <Fragment>
          {/* Header  */}
          <div
            className="flex items-center px-4 py-2.5 h-16 text-white"
            style={{
              boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.12)",
              background: settings["--site-widget-primary-color"],
            }}
          >
            <div
              className="flex items-center"
              onClick={() => {
                setFAQSectionActive(false);
                setSearchTerm("");
                setHelpArticles(configurations.help_center_articles);
              }}
            >
              <MdOutlineArrowBack className="cursor-pointer" />
              <p className="ml-2 fw-medium text-sm cursor-pointer">
                Help Centre
              </p>
            </div>
            <div
              className="max-w-[120px] absolute"
              style={{ transform: "translateX(-50%)", left: "50%" }}
            >
              <img
                src={settings.logo_url}
                className="w-auto text-center ml-5 max-h-12"
                alt={settings.merchant.storename}
              />
            </div>
          </div>
          <FAQSection
            helpArticles={helpArticles}
            setHelpArticles={setHelpArticles}
            setFAQSectionActive={setFAQSectionActive}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            settings={settings}
          />
        </Fragment>
      ) : (
        <div className="overflow-auto" style={{ height: "calc(100vh - 50px)" }}>
          {/* Header */}
          <div
            className="w-full rounded-b-xl p-5 pb-2 text-white header"
            style={{
              background: settings["--site-widget-primary-color"],
              minHeight: "150px",
            }}
          >
            <img
              src={settings.logo_url}
              className="w-auto mt-3 h-auto"
              alt="Brand Logo"
              style={{ maxWidth: "150px", maxHeight: "3rem" }}
            />
            <h1 className="text-xl mt-5">{settings.header_text}</h1>
            <h3 className="text-xs mt-3">{settings.sub_header_text}</h3>
            <StyledSocialIconsDiv
              className="flex items-center my-3"
              primarycolor={settings["--site-widget-primary-color"]}
            >
              {settings.social_media_channels &&
                settings.social_media_channels.channels.map((channel) => {
                  if (channel.enabled) {
                    return (
                      <div
                        className="rounded-half p-2 mx-0.5 social-icons cursor-pointer"
                        key={channel.title}
                        // onClick={() => track(channel.icon)}
                      >
                        <a href={channel.url} target="_blank" rel="noreferrer">
                          {channel.icon === "email" ? (
                            <AiOutlineMail className="social-icon text-xl" />
                          ) : channel.icon === "facebook" ? (
                            <FiFacebook className="social-icon text-xl" />
                          ) : channel.icon === "instagram" ? (
                            <FiInstagram className="social-icon text-xl" />
                          ) : channel.icon === "linkedin" ? (
                            <FiLinkedin className="social-icon text-xl" />
                          ) : channel.icon === "whatsapp" ? (
                            <FaWhatsapp className="social-icon text-xl" />
                          ) : channel.icon === "twitter" ? (
                            <FaXTwitter className="social-icon text-xl" />
                          ) : channel.icon === "youtube" ? (
                            <FaYoutube className="social-icon text-xl" />
                          ) : channel.icon === "youtube" ? (
                            <FaPinterest className="social-icon text-xl" />
                          ) : (
                            ""
                          )}
                        </a>
                      </div>
                    );
                  }
                })}
            </StyledSocialIconsDiv>
          </div>

          {settings.order_tracking_widget_enabled && (
            <Fragment>
              {otpVerified ? (
                <Fragment>
                  {/* Number edit Section  */}
                  <div className="p-5 flex items-center">
                    <p className="text-xs mt-1" style={{ color: "#585F6D" }}>
                      {phone !== null ? phone : email}
                    </p>
                    <FiEdit3
                      className="ml-3 text-sm mt-1"
                      style={{ color: "#151F32" }}
                    />
                    <p
                      className="text-xs ml-1 mt-1 cursor-pointer text-[#151F32]"
                      onClick={() => {
                        setOtpVerified(false);
                        setOtpSent(false);
                        setPhone(null);
                        setEmail(null);
                        // track("edit_username");
                        let iframe = document.getElementById("sessionIframe");
                        iframe.contentWindow.postMessage(
                          { phone: null, email: null, topic: "PRAGMA" },
                          "*"
                        );
                      }}
                    >
                      Change
                    </p>
                  </div>

                  {/* Order Tracking */}
                  <div className="flex items-center justify-between mx-3">
                    <div
                      className="flex text-white rounded-xl p-3 px-5 items-center cursor-pointer whitespace-nowrap justify-center"
                      style={{
                        background: settings["--site-widget-primary-color"],
                        width: settings.rms_enabled ? "auto" : "100%",
                      }}
                      onClick={() => {
                        trackOrders(accessToken);
                        // track("clicked_order_tracking");
                      }}
                    >
                      <FiPackage />
                      <p className="ml-2 font-medium">Track Order</p>
                    </div>
                    {settings.rms_enabled && (
                      <div
                        className="flex text-white rounded-xl p-3 ml-2 whitespace-nowrap items-center cursor-pointer w-full justify-center"
                        style={{
                          background: settings["--site-widget-primary-color"],
                        }}
                        onClick={() => {
                          trackOrders(accessToken);
                          // track("clicked_returns");
                        }}
                      >
                        <MdOutlineReplay />
                        <p className="ml-2 font-medium">Returns / Exchange</p>
                      </div>
                    )}
                  </div>
                  <p className="text-xs px-5 mt-2" style={{ color: "#585F6D" }}>
                    Track orders, report issues, initiate returns and more.
                  </p>
                </Fragment>
              ) : (
                <div className="p-5 pb-0">
                  {/* Login Section  */}
                  <p className="mb-2 text-sm font-medium text-[#424A59]">
                    Manage your orders
                  </p>
                  <Login
                    setOtpVerified={setOtpVerified}
                    email={email}
                    setEmail={setEmail}
                    phone={phone}
                    setPhone={setPhone}
                    settings={settings}
                    otpSent={otpSent}
                    setOtpSent={setOtpSent}
                    trackOrders={trackOrders}
                    accessToken={accessToken}
                    setAccessToken={setAccessToken}
                  />
                </div>
              )}
            </Fragment>
          )}

          {/* Chat on Whatsapp */}
          {settings?.social_media_channels?.channels?.filter(
            (channel) => channel.icon === "whatsapp"
          ).length > 0 && (
            <div className="px-5">
              <a
                href={
                  settings?.social_media_channels?.channels?.filter(
                    (channel) => channel.icon === "whatsapp"
                  )[0]?.url
                }
                className="flex items-center"
                target="_blank"
              >
                <button className="rounded-xl border border-[#C8CACE] w-full mt-4 p-2 px-5">
                  <div className="flex items-center">
                    <IoLogoWhatsapp color="#25D366" className="mr-2" />
                    Chat with us on Whatsapp
                  </div>
                  <span className="italic text-[#33333399] text-xs flex">
                    {settings.whatsapp_support_statement}
                  </span>
                </button>
              </a>
            </div>
          )}

          {/* Leave a message section  */}

          {settings.query_widget_enabled && (
            <div className="px-5">
              <button
                className="rounded-xl border border-[#C8CACE] w-full mt-4 p-2 px-5 flex items-center"
                onClick={() => {
                  setOpenForm(true);
                  // track("clicked_leave_message");
                }}
              >
                Leave a message
                <RiArrowRightSLine className="ml-auto text-xl font-bold" />
              </button>
            </div>
          )}

          {settings.help_center_widget_enabled && (
            <div>
              <p
                className="px-5 font-medium text-sm mt-5"
                style={{ color: "#424A59" }}
              >
                Help Centre
              </p>
              <FAQSection
                helpArticles={helpArticles.slice(0, 3)}
                setHelpArticles={setHelpArticles}
                setFAQSectionActive={setFAQSectionActive}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                settings={settings}
              />

              <div>
                <p
                  className="text-sm flex items-center cursor-pointer px-5 whitespace-nowrap"
                  onClick={() => {
                    // track("clicked_view_all_faqs");
                    getHelpArticles(settings.merchant.id).then((resp) => {
                      setHelpArticles(resp.data.data);
                      setFAQSectionActive(true);
                    });
                  }}
                >
                  View All <RiArrowRightSLine className="ml-0.5 mt-0.5" />
                </p>
              </div>
            </div>
          )}
          {settings.is_pragma_branding_visible && (
            <Footer settings={settings} help={false} />
          )}
        </div>
      )}
    </div>
  );
}

export default App;
